import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { ClinicInvoiceTerm } from 'infrastructure/enums';

import useApi from '../use-api';

import type { IClinicInvoiceInfo } from 'infrastructure/interfaces';

const api = (clinicGuid: string) => `core-2/clinics/${clinicGuid}/invoice-info`;

interface IProps {
  clinicGuid: string;
}

export const useGetInvoiceInfo = (props: IProps) => {
  const { clinicGuid } = props;
  const { loadData } = useApi();

  const queryKey = [api(clinicGuid)];

  const emptyValue: IClinicInvoiceInfo = {
    clinicGuid: '',
    invoiceFolder: '',
    invoiceNPI: '',
    customerTypeGuid: '',
    invoiceTerms: ClinicInvoiceTerm.NET_30,
  };

  const {
    data = emptyValue,
    isFetching,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () =>
      loadData<IClinicInvoiceInfo>(api(clinicGuid)).then((res) => {
        if (res) {
          return res;
        }
      }),
    staleTime: STALE_TIME,
    enabled: !!clinicGuid,
  });

  return {
    data,
    loading: isFetching,
    refetch,
  };
};
